import PocketBase from 'pocketbase'

// PocketBase client singleton.
// In production: Caddy proxies /api/ to PB, so window.location.origin works.
// In dev: connect directly to PB on port 8090 for real-time subscriptions (WebSocket).
const pbUrl = import.meta.env.DEV
  ? `${window.location.protocol}//${window.location.hostname}:8090`
  : window.location.origin

const pb = new PocketBase(pbUrl)

// Disable auto-cancellation globally. PB SDK cancels in-flight requests
// to the same collection by default, which breaks React Query's concurrent
// fetches from multiple hooks/components.
pb.autoCancellation(false)

// Debug: expose on window for troubleshooting auth issues
if (import.meta.env.DEV) {
  ;(window as any).__pb = pb
}

export default pb
